import { render, staticRenderFns } from "./AlertsSettings.vue?vue&type=template&id=014ac908&"
import script from "./AlertsSettings.vue?vue&type=script&lang=js&"
export * from "./AlertsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports